<template>
  <div class="aside-box">
    <div class="title-box">
      <p class="title">轮播图</p>
    </div>
    <div class="box-body" style="padding-bottom: 20px">
      <div class="info-content nav-info-content">
        <ul class="nav-list swiper-list" id="nav-list">
          <li
            class="nav-li swiper-li"
            v-for="(item3, index3) in swiperList"
            :key="index3"
          >
            <div class="nav-header">
              <p>轮播图{{ index3 + 1 }}</p>
              <div class="del-nav-icon" @click="delSwiper(index3)"></div>
            </div>
            <div class="nav-body swiper-body">
              <div class="nav-name swiper-img">
                <span>*</span>
                <p>轮播图</p>
                <div class="create-swiper-box">
                  <div class="create-swiper-btn" @click="createSwiper(index3)">
                    <img
                      src="../../../assets/images/pc-decoration/create-swiper-icon.png"
                      alt=""
                      class="create-swiper-icon"
                    />
                    <p>在线制作</p>
                  </div>
                  <div class="upload-swiper-btn" @click="uploadSwiper(index3)">
                    <img
                      src="../../../assets/images/pc-decoration/upload-swiper-icon.png"
                      alt=""
                      class="upload-swiper-icon"
                    />
                    <p>上传图片</p>
                  </div>
                </div>
              </div>
              <div class="swiper-show">
                <div class="swiper-tips">
                  尺寸为686px*220px，支持JPG、PNG，大小不超过500KB
                </div>
              </div>
              <div v-if="item3.swiperImg" class="swiper-show">
                <img :src="item3.swiperImg" class="swiper-img-show" />
              </div>
              <div class="nav-url swiper-url">
                <p>跳转链接</p>
                <el-select
                  v-model="item3.linkType"
                  clearable
                  class="nav-url-input"
                  placeholder="请选择跳转的页面"
                  @visible-change="visibleHandler(item3.linkType, index3)"
                  @clear="clearHandler(index3)"
                >
                  <el-option
                    v-for="(item4, index4) in options"
                    :key="index4"
                    :label="item4.label"
                    :value="item4.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </li>
        </ul>
        <div class="add-content-li" @click="addSwiperContent()">
          <span>+</span>
          <p>添加轮播图</p>
          <div>（{{ swiperList.length }}/5）</div>
        </div>
      </div>
    </div>
    <input
      ref="swiperFile"
      type="file"
      id="swiper-file"
      @change="selectFile"
      accept=".jpg,.png,.jpeg"
      style="display: none"
    />
  </div>
</template>

<script>
import Sortable from "sortablejs";
import api from "../../../assets/js/api";
export default {
  name: "ShopCenterAdminWebMAsideSwiper",
  props: {
    floor: {
      type: Object,
    },
  },
  data() {
    return {
      swiperList: [],
      options: [
        {
          label: "内容",
          value: 1,
        },
        {
          label: "导航",
          value: 2,
        },
      ],
      types: [
        // 允许的文件格式
        "jpg",
        "jpeg",
        "png",
      ],
      currentIndex: -1, // 当前操作的模块的index
    };
  },
  watch: {
    "floor.index": {
      handler() {
        // 获取轮播图数据
        this.swiperList = JSON.parse(
          JSON.stringify(
            this.$store.state.mDecoration.floorList[this.floor.index]
              .contentList
          )
        );
        // 开启拖拽功能
        this.$nextTick(() => {
          // 开启拖拽排序
          var el = document.getElementById("nav-list");
          new Sortable(el, {
            animation: 150,
            filter: ".no-change",
            onUpdate: (evt) => {
              // 改变数组排序
              const temp = this.swiperList[evt.oldIndex];
              this.swiperList.splice(evt.oldIndex, 1);
              this.swiperList.splice(evt.newIndex, 0, temp);
              // 重新按顺序渲染dom 确保视图和数据一致
              const arr = this.swiperList.slice(0);
              this.swiperList = [];
              this.$nextTick(() => {
                this.swiperList = arr;
                this.updateVuex();
              });
            },
          });
        });
      },
      immediate: true,
      deep: true,
    },
    "$store.state.mDecoration.currentFloor": {
      handler(newValue) {
        // console.log("组件监听到了currentFloor的变化----", newValue, this.floor);
        if (newValue.id == 207 && this.floor.key == newValue.key) {
          // 获取轮播图数据
          this.swiperList = JSON.parse(JSON.stringify(newValue.contentList));
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},

  methods: {
    // 获得焦点时根据是否选择链接类型绑定事件
    visibleHandler(type, index) {
      // 获取所有的下拉列表中的元素
      const els = document.querySelectorAll(".el-select-dropdown__item");
      // 如果是展开下拉列表 则绑定事件
      if (els) {
        els.forEach((el) => {
          el.onclick = () => {
            // 显示对应的弹窗
            this.showDialog(type, index);
          };
        });
      }
      // 如果是收起下拉列表 则清除绑定的事件
      // if (!e) {
      // 等待dom更新之后再清除事件
      // this.$nextTick(() => {
      //   els.forEach((el) => {
      //     el.onclick = null;
      //   });
      // });
      // }
    },
    // 下拉框清除事件
    clearHandler(index) {
      // 清除对应的数据
      this.swiperList[index].linkType = "";
      this.swiperList[index].link = "";
      // 更新数据到vuex中
      this.updateVuex();
    },
    // 显示对应的弹窗
    showDialog(type, index) {
      if (!type) return;
      // 存储当前的轮播图的index
      this.$store.commit("mDecoration/setCurrentContentIndex", index);
      // 显示对应的弹窗
      this.$store.commit("mDecoration/setDialogType", `link${type}`);
    },
    // 添加轮播图
    addSwiperContent() {
      // 最多添加5个
      if (this.swiperList.length >= 5) {
        this.$message({
          message: "最多添加5个轮播图",
          type: "warning",
        });
        return;
      }
      this.swiperList.push({
        swiperImg: "",
        link: "",
        linkType: "",
      });
      // 更新数据到vuex中
      this.updateVuex();
    },
    // 删除轮播图
    delSwiper(index) {
      this.swiperList.splice(index, 1);
      // 更新数据到vuex中
      this.updateVuex();
    },
    // 制作轮播图
    createSwiper(index) {
      const handler = (messageEvent) => {
        var imgPath = messageEvent.data;
        if (typeof imgPath == "string") {
          this.$set(this.swiperList[index], "swiperImg", imgPath); // 将生成的banner赋给banner列表
          window.removeEventListener("message", handler);
          // this.$refs.barXkw.src = "";
          // 更新数据到vuex中
          this.updateVuex();
          this.$store.commit("mDecoration/setDialogType", "");
        }
      };
      window.addEventListener("message", handler, false);
      // 更新数据到vuex中
      this.$store.commit("mDecoration/setDialogType", "createSwiper");
    },
    // 模拟点击上传
    uploadSwiper(index) {
      this.currentIndex = index;
      // 清除input标签缓存
      this.$refs.swiperFile.value = "";
      // 模拟点击
      this.$refs.swiperFile.click();
    },
    // 选择要上传的图片
    selectFile(e) {
      const file = e.target.files[0];
      const typeArr = file.type.split("/");
      if (typeArr[0] !== "image" || !this.types.includes(typeArr[1])) {
        this.$message.error("图片格式不正确，请重新选择~");
        return;
      } else if (file.size > 1024 * 500) {
        this.$message.error("图片文件大小不能超过500KB~");
        return;
      } else {
        // 这个地方开始上传封面
        this.uploadImage(file);
      }
    },

    // 上传图片
    async uploadImage(file) {
      const loading = this.$loading({
        lock: true,
        customClass: "loading",
      });
      // 上传图片
      const formDate = new FormData();
      formDate.append("file", file);
      const res = await this.$axios.post(
        api.decoration.uploadEditorImage,
        formDate
      );
      // console.log("res---", res);
      // 关闭loading
      loading.close();
      if (res.result && res.result.success) {
        // 将上传的banner赋给banner列表
        this.$set(
          this.swiperList[this.currentIndex],
          "swiperImg",
          res.result.filePath
        );
        // 更新数据到vuex中
        this.updateVuex();
        this.$message({
          message: "图片上传成功~",
          type: "success",
        });
      } else {
        this.$message({
          message: `图片上传失败，${res.error.message}`,
          type: "error",
        });
      }
    },
    // 更新数据到vuex中
    updateVuex() {
      const list = JSON.parse(
        JSON.stringify(this.$store.state.mDecoration.floorList)
      );
      list[this.floor.index].contentList = this.swiperList;
      // 更新楼层列表信息
      this.$store.commit("mDecoration/setFloorList", list);
      // 更新当前楼层信息
      this.$store.commit("mDecoration/setCurrentFloor", list[this.floor.index]);
    },
  },
};
</script>

<style lang="scss" scoped>
.aside-box {
  .title-box {
    margin: 0px 0 20px;
    .title {
      color: #606266;
      font-size: 15px;
      font-style: normal;
      line-height: 15px;
      margin-right: 20px;
    }
  }
  .box-body {
    .info-content {
      padding-left: 12px;

      .info-content-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 24px;

        & > span {
          margin-right: 4px;
          font-size: 15px;
          font-weight: 600;
          color: #fe4509;
        }

        & > p {
          width: 80px;
          font-size: 12px;
          color: #606266;
        }
        & > div {
          width: 220px;
        }

        ::v-deep .el-radio-group.group-type2 .el-radio {
          margin-bottom: 20px;
        }
      }

      .info-content-item2 {
        transform: translateX(-12px);
      }

      .zdy-content {
        .content-list {
          .content-li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 280px;
            height: 32px;
            padding: 0 15px;
            margin-bottom: 15px;
            background: #f5f5f5;
            border-radius: 5px;

            p {
              width: 250px;
              font-size: 12px;
              color: #606266;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .del-content-icon {
              width: 11px;
              height: 12px;
              background: url(../../../assets/images/pc-decoration/del-floor-icon.png)
                no-repeat;
              background-size: 100% 100%;
              cursor: pointer;

              &:hover {
                background: url(../../../assets/images/pc-decoration/del-floor-icon2.png)
                  no-repeat;
                background-size: 100% 100%;
              }
            }
          }
        }
      }

      .nav-list {
        .nav-li {
          width: 278px;
          height: 180px;
          padding: 15px 15px;
          margin-bottom: 20px;
          background: #ffffff;
          border: 1px dashed transparent;

          .nav-header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            p {
              font-weight: 500;
              font-size: 13px;
              color: #606266;
            }

            .del-nav-icon {
              display: none;
              width: 11px;
              height: 12px;
              background: url(../../../assets/images/pc-decoration/del-floor-icon.png)
                no-repeat;
              background-size: 100% 100%;
              cursor: pointer;

              &:hover {
                background: url(../../../assets/images/pc-decoration/del-floor-icon2.png)
                  no-repeat;
                background-size: 100% 100%;
              }
            }
          }
          &:hover {
            border: 1px dashed #c0d0ff;
            box-shadow: 0px 0px 10px rgba(191, 191, 191, 0.25);
            border-radius: 5px;

            .del-nav-icon {
              display: block;
            }
          }
          .nav-body {
            margin-top: 15px;

            & > div {
              display: flex;
              align-items: center;
              justify-content: flex-start;

              p {
                width: 70px;
                font-size: 12px;
                color: #606266;
                white-space: nowrap;
              }
            }
            .nav-name {
              margin-bottom: 15px;
              span {
                margin-left: -9px;
                margin-right: 4px;
                font-size: 12px;
                font-weight: 600;
                color: #fe4509;
              }
              .nav-name-input {
                width: 210px;
              }
            }

            .nav-img {
              margin-bottom: 15px;

              .nav-img-box {
                position: relative;
                width: 30px;
                height: 30px;
                margin-right: 10px;
                border-radius: 5px;
                background-size: 100% 100%;
                transition: all 0.2s linear;

                .del-img-box {
                  display: none;
                  align-items: center;
                  justify-content: center;
                  position: absolute;
                  top: 0px;
                  right: 0px;
                  left: 0px;
                  bottom: 0px;
                  width: 100%;
                  height: 100%;
                  background: rgba(0, 0, 0, 0.4);
                  border-radius: 5px;

                  .del-img-icon {
                    width: 11px;
                    height: 12px;
                    background: url(../../../assets/images/pc-decoration/del-floor-icon3.png)
                      no-repeat;
                    background-size: 100% 100%;
                    cursor: pointer;

                    &:hover {
                      background: url(../../../assets/images/pc-decoration/del-floor-icon2.png)
                        no-repeat;
                      background-size: 100% 100%;
                    }
                  }
                }

                &:hover {
                  .del-img-box {
                    display: flex;
                  }
                }
              }

              .add-img-box {
                width: 30px;
                height: 30px;
                margin-right: 10px;
                background: #ffffff;
                border: 1px dashed #a3baff;
                border-radius: 5px;
                font-size: 18px;
                text-align: center;
                line-height: 28px;
                font-weight: 500;
                color: #5a83ff;
                cursor: pointer;
              }
              .nav-img-tips {
                width: 175px;
                font-size: 12px;
                color: #c4c8d0;
              }
            }

            .nav-url {
              .nav-url-input {
                width: 210px;
              }
            }
          }
        }
      }

      .swiper-list {
        .swiper-li {
          height: auto;
          min-height: 180px;
          .swiper-body {
            .swiper-img-show {
              width: 210px;
              height: 40px;
              margin-top: 5px;
              border-radius: 5px;
            }
            .swiper-img {
              .create-swiper-box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 210px;
              }
              .create-swiper-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 98px;
                height: 30px;
                background: #ffffff;
                border: 1px solid #a2baff;
                border-radius: 5px;
                cursor: pointer;

                .create-swiper-icon {
                  width: 9px;
                  height: 12px;
                  margin-right: 5px;
                }

                p {
                  width: 50px;
                  font-size: 12px;
                  color: #5a83ff;
                }
              }
              .upload-swiper-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 98px;
                height: 30px;
                background: #ffffff;
                border: 1px solid #a2baff;
                border-radius: 5px;
                cursor: pointer;

                .upload-swiper-icon {
                  width: 10px;
                  height: 10px;
                  margin-right: 4px;
                }

                p {
                  width: 50px;
                  font-size: 12px;
                  color: #5a83ff;
                }
              }
            }
            .swiper-tips {
              color: #c4c8d0;
            }
            .swiper-url {
              margin-top: 20px;
            }
            .swiper-show {
              padding-left: 72px;
            }
          }
        }
      }
      .show-shop-info {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        .shop-info-title {
          width: 70px;
          margin-right: 12px;
          font-size: 12px;
          color: #606266;

          span {
            font-weight: 600;
            font-size: 12px;
            color: #fe4509;
          }
        }
        .shop-info-list {
          width: 230px;
          overflow: hidden;

          .shop-info-li {
            float: left;
            width: 75px;
            margin-bottom: 10px;

            ::v-deep .el-checkbox__label {
              font-size: 12px;
              color: #606266;
            }
          }
        }
      }
      .info-origin {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 20px;
        .info-title {
          width: 70px;
          margin-right: 12px;
          font-size: 12px;
          color: #606266;

          span {
            font-weight: 600;
            font-size: 12px;
            color: #fe4509;
          }
        }
        ::v-deep .el-input--suffix .el-input__inner {
          width: 220px;
        }
        ::v-deep .el-scrollbar__wrap {
          overflow-x: auto !important;
        }
      }
      .info-order {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        .info-title {
          width: 70px;
          margin-right: 12px;
          font-size: 12px;
          color: #606266;

          span {
            font-weight: 600;
            font-size: 12px;
            color: #fe4509;
          }
        }

        ::v-deep .el-radio-group {
          width: 220px;

          .el-radio {
            margin-bottom: 20px;
          }
        }
      }
      .add-content-li {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 310px;
        height: 32px;
        margin-bottom: 30px;
        background: #ffffff;
        border: 1px dashed #5a83ff;
        border-radius: 5px;
        cursor: pointer;

        span {
          font-size: 20px;
          font-weight: 500;
          transform: translate(-2px, -2px);
          color: #5a83ff;
        }

        p {
          font-size: 14px;
          color: #5a83ff;
        }
        div {
          font-size: 12px;
          color: #c4c8d0;
        }

        .edit-icon {
          width: 9px;
          height: 12px;
          margin-right: 5px;
        }
      }
    }
    .nav-info-content {
      padding-bottom: 30px;
    }
  }
}
</style>
